import { Card, CardTitle, CardDescription, CardHeader, CardContent } from '@/components/ui/card';
import { cn } from 'src/lib/utils';

type Props = {
  title: string;
  className?: string;
  description?: string;
  action?: React.ReactNode;
  contentClassName?: string;
};

const BillingCard = ({
  title,
  className,
  description,
  children,
  action,
  contentClassName,
}: React.PropsWithChildren<Props>) => {
  return (
    <Card className={cn('relative', className)}>
      <CardHeader>
        <div className="flex items-center justify-between gap-2">
          <div className="flex flex-col gap-1 grow-1">
            <CardTitle className="text-lg sm:text-xl text-foreground">{title}</CardTitle>
            {description && (
              <CardDescription className="text-xs sm:text-sm text-muted-foreground">{description}</CardDescription>
            )}
          </div>
          {action && action}
        </div>
      </CardHeader>
      <CardContent className={contentClassName}>{children}</CardContent>
    </Card>
  );
};

export default BillingCard;
